(function () {
  'use strict';

  function smoothScrollTo(targetEl) {
    if (!targetEl) return;
    // Honour any scroll-margin-top on the target via scrollIntoView.
    targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setNavLinkActive(container, handle, isActive) {
    var link = container.querySelector('[data-sh-nav-link="' + handle + '"]');
    if (!link) return;
    if (isActive) {
      link.setAttribute('aria-current', 'true');
    } else {
      link.removeAttribute('aria-current');
    }
  }

  function setCategoryOpen(container, target, open) {
    if (!target) return;
    var handle = target.getAttribute('data-sh-cat');
    var toggle = target.querySelector('[data-sh-toggle]');
    target.classList.toggle('is-expanded', open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    setNavLinkActive(container, handle, open);
  }

  function initSidebar(container) {
    var links = container.querySelectorAll('[data-sh-nav-link]');
    if (!links.length) return null;

    function onLinkClick(e) {
      var link = e.currentTarget;
      var handle = link.getAttribute('data-sh-nav-link');
      var target = container.querySelector('[data-sh-cat="' + handle + '"]');
      if (!target) return;
      e.preventDefault();

      var isOpen = target.classList.contains('is-expanded');

      if (isOpen) {
        setCategoryOpen(container, target, false);
      } else {
        setCategoryOpen(container, target, true);
        smoothScrollTo(target);
      }

      if (history && history.replaceState) {
        history.replaceState(null, '', '#cat-' + handle);
      }
    }

    links.forEach(function (link) { link.addEventListener('click', onLinkClick); });

    return function cleanup() {
      links.forEach(function (link) { link.removeEventListener('click', onLinkClick); });
    };
  }

  function initExpanders(container) {
    var toggles = container.querySelectorAll('[data-sh-toggle]');
    if (!toggles.length) return null;

    function onToggle(e) {
      var button = e.currentTarget;
      var cat = button.closest('[data-sh-cat]');
      if (!cat) return;
      var expanded = button.getAttribute('aria-expanded') === 'true';
      var next = !expanded;
      setCategoryOpen(container, cat, next);

      var more = button.querySelector('[data-sh-toggle-more]');
      var less = button.querySelector('[data-sh-toggle-less]');
      if (more && less) {
        more.hidden = next;
        less.hidden = !next;
      }

      if (next) {
        // Focus the first newly-revealed card link for keyboard users.
        var firstHidden = cat.querySelector('.sv-card--hidden .sv-card__link');
        if (firstHidden) firstHidden.focus({ preventScroll: true });
      }
    }

    toggles.forEach(function (b) { b.addEventListener('click', onToggle); });

    return function cleanup() {
      toggles.forEach(function (b) { b.removeEventListener('click', onToggle); });
    };
  }

  function init(container) {
    if (!container || container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var cleanups = [];
    var c1 = initSidebar(container);
    if (c1) cleanups.push(c1);
    var c2 = initExpanders(container);
    if (c2) cleanups.push(c2);

    // Default open: hash-targeted category if present, otherwise the first one.
    var hashHandle = null;
    if (window.location.hash && window.location.hash.indexOf('#cat-') === 0) {
      hashHandle = window.location.hash.slice(5);
    }

    var initialTarget = null;
    if (hashHandle) {
      initialTarget = container.querySelector('[data-sh-cat="' + hashHandle + '"]');
    }
    if (!initialTarget) {
      initialTarget = container.querySelector('[data-sh-cat]');
    }

    if (initialTarget) {
      setCategoryOpen(container, initialTarget, true);

      if (hashHandle) {
        window.requestAnimationFrame(function () {
          initialTarget.scrollIntoView({ block: 'start' });
        });
      }
    }

    container._supportHubCleanup = function () {
      cleanups.forEach(function (fn) {
        try { fn(); } catch (err) { /* noop */ }
      });
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._supportHubCleanup === 'function') {
      container._supportHubCleanup();
    }
    container.dataset.bound = '';
  }

  function bootAll() {
    document.querySelectorAll('[data-section-type="support-hub"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="support-hub"]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="support-hub"]').forEach(destroy);
  });
})();
